import DropdownTreeSelect from "react-dropdown-tree-select";
import { AlertError, checkDefaultRegion, disableRegionsByType } from "../helpers";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import {Container, Table} from "react-bootstrap";
import {AuthUserContext} from "../context/AuthUser";
import { EWineProperties, OptionType, RegionHierarchy, TErrorObject } from "../properties";
import axios from "axios";
import Select from "react-select";
import {toast} from "react-toastify";
import {ArrowsCollapse, Pencil, Plus, PlusSquare, DashSquare} from "react-bootstrap-icons";
import BsModal from "../components/BsModal";

type RegionProps = {
    name: string,
    id: number,
    depth: number,
    parent_id: number,
    children: RegionProps[]
}

const Regions = () => {
    const authUser = useContext(AuthUserContext);
    const axiosConfig = {
        headers: {
            Authorization: authUser.authUser !== null ? "Bearer " + authUser.authUser.api_key : ''
        }
    };
    const [error, setError] = useState<string | TErrorObject>('');
    const [countries, setCountries] = useState<null | OptionType[]>(null);
    const [regions, setRegions] = useState<RegionProps[]>([]);
    const [tableRegions, setTableRegions] = useState<RegionProps[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<OptionType | null>(null);
    const [selectedRegions, setSelectedRegions] = useState<number[]>([]);
    const [disabledEdit, setDisabledEdit] = useState(true);
    const [disabledMerge, setDisabledMerge] = useState(true);
    const [disabledNewRegion, setDisabledNewRegion] = useState(true);
    const [checkboxDisabled, setCheckboxDisabled] = useState(false);
    const [openModalEditRegion, setOpenModalEditRegion] = useState(false);
    const [openModalAddRegion, setOpenModalAddRegion] = useState(false);
    const [mergeIn, setMergeIn] = useState<number>(0);
    const defaultMergeInIndex = 0;
    const [editLocationId, setEditLocationId] = useState(0);
    const [editRegionName, setEditRegionName] = useState('');
    const [newRegionName, setNewRegionName] = useState('');
    const [canLockCountry, setCanLockCountry] = useState(false);
    const [lockCountryChecked, setLockCountryChecked] = useState(false);
    const [winesCounter, setWinesCounter] = useState<{ [key: number]: number }>();
    const [gustosWinesCounter, setGustosWinesCounter] = useState<{ [key: number]: number }>();
    const [earth, setEarth] = useState<RegionHierarchy[]>([]);
    const [visibleRegions, setVisibleRegions] = useState<number[]>([]);
    const [openedParentRegion, setOpenedParentRegion] = useState<number[]>([]);

    const searchRegions = () => {
        resetAll();

        if (selectedCountry) {
            axios.get('/api/load-country-regions-tree?country=' + selectedCountry.value, {
                ...axiosConfig
            }).then(r => {
                let result = r.data;
                if (result.hasOwnProperty("regions")) {
                    setRegions(result.regions);
                }

                if (result.hasOwnProperty('wines_count') && result.wines_count) {
                    setWinesCounter(result.wines_count);
                }

                if (result.hasOwnProperty('gustos_wines_count') && result.gustos_wines_count) {
                    setGustosWinesCounter(result.gustos_wines_count);
                }

                if (result.hasOwnProperty('earth')) {
                    setEarth(result.earth);
                }

                setOpenedParentRegion([]);
            }).catch(error => {

            }).finally(() => {
                setDisabledNewRegion(false);
            });

            axios.post('/api/lock-country-status', {country_id: selectedCountry.value}, {
                ...axiosConfig
            }).then(r => {
                let result = r.data;
                if (result.hasOwnProperty('status')) {
                    setCanLockCountry(true);
                    setLockCountryChecked(result.status);
                }
            });
        }
    }

    const resetAll = () => {
        setSelectedRegions([]);
        setDisabledEdit(true);
        setDisabledMerge(true);
        setDisabledNewRegion(true);
        setMergeIn(0);
        setCheckboxDisabled(false);
        setCanLockCountry(false);
    }

    const toggleActions = (item: number, is_checked: boolean) => {
        let selectedCount;
        if (is_checked) {
            selectedRegions.push(item);
            setSelectedRegions(selectedRegions.map(f => f));
            selectedCount = selectedRegions.length;
        } else {
            let filtered = selectedRegions.filter(e => e !== item);
            setSelectedRegions(filtered.map(f => f));
            selectedCount = filtered.length;

            if (mergeIn && mergeIn === item) {
                setMergeIn(0);
            }
        }

        switch (selectedCount) {
            case 0:
                setDisabledEdit(true);
                setDisabledMerge(true);
                break;
            case 1:
                setDisabledEdit(false);
                setDisabledMerge(true);
                break;
            default:
                setDisabledEdit(true);
                setDisabledMerge(false);
        }
    }

    const ModalEditRegionProps = {
        showModal: openModalEditRegion,
        hideModal: () => {
            hideEditRegionModal();
        },
        title: "Edit region",
        primaryButton: {
            title: 'Save',
            onClick: () => {
                saveEditRegion();
            }
        },
        confirmButton: false,
        bsError: ''
    }

    const ModalAddRegionProps = {
        showModal: openModalAddRegion,
        hideModal: () => {
            hideAddRegionModal();
        },
        title: "Add new region",
        primaryButton: {
            title: 'Save',
            onClick: () => {
                saveAddRegion();
            }
        },
        confirmButton: false,
        bsError: ''
    }

    const hideEditRegionModal = () => {
        setEditRegionName('');
        setOpenModalEditRegion(false);
    }

    const hideAddRegionModal = () => {
        setOpenModalAddRegion(false);
    }

    const saveEditRegion = () => {

        if (editRegionName && editLocationId !== 0 && selectedRegions.length === 1) {
            axios.post('/api/update-region', {
                'id': selectedRegions[0],
                'name': editRegionName,
                'country': editLocationId
            }, {
                ...axiosConfig
            }).then(r => {
                let result = r.data;

                if (result.hasOwnProperty('error')) {
                    toast.error(result.error);
                    return false;
                }

                if (result.hasOwnProperty('success')) {

                    setOpenModalEditRegion(false);

                    if (regions) {
                        searchRegions();

                        setEditRegionName('');
                        setEditLocationId(0);
                    }

                    toast.success(result.msg);
                    return true;
                }
            }).catch(r => {

            })
        }
    }

    const saveAddRegion = () => {
        if (newRegionName !== '' && editLocationId !== 0) {
            axios.post('/api/store-region', {
                region: newRegionName,
                country: editLocationId
            }, {
                ...axiosConfig
            }).then(r => {
                let result = r.data;

                if (result.hasOwnProperty('err')) {
                    toast.error(result.err);
                    return false;
                }

                if (result.hasOwnProperty("region")) {
                    setOpenModalAddRegion(false);

                    searchRegions();

                    setNewRegionName("");
                    setEditLocationId(0);
                }
            });
        }
    }

    const mergeRegions = () => {
        if (!window.confirm('Are you sure want to merge regions?')) {
            return false;
        }

        if (selectedRegions.length && selectedRegions.length >= 2) {
            const mergeId = mergeIn || selectedRegions[defaultMergeInIndex];

            axios.post('/api/merge-regions', {
                'merge_in': mergeId,
                'regions': selectedRegions
            }, {
                ...axiosConfig
            }).then(r => {
                let result = r.data;
                if (result.hasOwnProperty('error')) {
                    toast.error(result.error);
                    return false;
                }
                if (result.hasOwnProperty('success')) {

                    searchRegions();

                    toast.success(result.msg);
                    return true;
                }

            }).catch(error => {
                console.log(error.toString());
            })
        }
    }

    const lockCountry = (lock: boolean, country: string | undefined) => {
        setCanLockCountry(false);
        axios.post('/api/lock-country', {
            lock: lock,
            country_id: country
        }, {
            ...axiosConfig
        }).then(r => {
            let result = r.data;
            if (result.hasOwnProperty('error')) {
                toast.error(result.error);
                return false;
            }

            if (result.hasOwnProperty('success')) {
                let msg = 'Country successfully ' + (lock ? 'locked' : 'unlocked');
                setLockCountryChecked(lock);
                toast.success(msg);
                return true;
            }
        }).catch(error => {
            console.log(error.toString());
        }).finally(() => {
            setCanLockCountry(true);
        });
    }

    const onChangeManageRegion = useCallback((_, selectedNodes) => {
        setEditLocationId(selectedNodes.length ? selectedNodes[0].value : 0);
    }, []);

    const DropdownRegion = useMemo(() => {
        return <DropdownTreeSelect
              onChange={onChangeManageRegion}
              data={earth}
              className="custom-dropdown-tree mt-1"
              mode={"radioSelect"}
              texts={{ placeholder: "Select location" }}
              inlineSearchInput
              keepTreeOnSearch
              keepChildrenOnSearch
            />
    }, [earth]);

    const beforeOpenEditRegionModal = () => {
        const parent_id = regions.find(e => e.id === selectedRegions[0])?.parent_id;
        setEditRegionName(regions.find(e => e.id === selectedRegions[0])?.name || "");
        setEditLocationId(Number(parent_id));

        let earthUpdated = checkDefaultRegion(earth, String(parent_id), true);
        earthUpdated = disableRegionsByType(earthUpdated, 'CONTINENT');

        setEarth(earthUpdated);
        setOpenModalEditRegion(true);
    };

    const beforeOpenAddRegionModal = () => {
        if (selectedCountry) {
            setEarth(checkDefaultRegion(earth, String(selectedCountry.value), true));
            setEditLocationId(Number(selectedCountry.value));
        }
        setOpenModalAddRegion(true);
    };

    const getChildren = (data: RegionProps[], parentId: number) => {
        const directChildren = data.filter(item => String(item.parent_id) === String(parentId));
        let allChildren = [...directChildren];

        directChildren.forEach(child => {
            allChildren = [...allChildren, ...getChildren(data, child.id)];
        });

        return allChildren;
    }

    const getChildrenWithOwnChildren = (list: RegionProps[], parentId: number) => {
        const directChildren = list.filter(item => String(item.parent_id) === String(parentId));
        return directChildren
            .filter(child => list.some(item => String(item.parent_id) === String(child.id)))
            .map(child => child.id);
    }

    const toggleRegionChildren = (id: number) => {
        // Get ids where parent_id is equal to the current id.
        const childrenIds = regions.filter(region => String(region.parent_id) === String(id)).map(region => region.id);

        setOpenedParentRegion((prev) => {
            if (prev.includes(id)) {
                const childrenWithOwnChildren = getChildrenWithOwnChildren(regions, id);
                // If the parent is already opened, close it and remove its children.
                return prev.filter(regionId => regionId !== id && !childrenWithOwnChildren.includes(regionId));
            } else {
                return [...prev, id];
            }
        });

        // Check if the children ids already exist in visibleRegions.
        const isChildrenVisible = childrenIds.every(childId => visibleRegions.includes(childId));
        if (isChildrenVisible) {
            const allChildren = getChildren(regions, id);

            // If all children are visible, hide them.
            setVisibleRegions(visibleRegions.filter(regionId => !allChildren.map(child => child.id).includes(regionId)));
            return;
        }

        // Toggle visibility of children regions.
        setVisibleRegions([...visibleRegions, ...childrenIds]);
    }

    useEffect(() => {
        axios.get('/api/taxonomy-property?property=' + EWineProperties.country, {
            ...axiosConfig
        }).then(r => {
            let result = r.data;
            if (result.hasOwnProperty('taxonomy') && result.taxonomy.hasOwnProperty(EWineProperties.country)) {
                setCountries(result.taxonomy[EWineProperties.country]);
            } else {
                toast.error('No data');
            }
        }).catch(error => {
            console.log(error.toString());
        })
    }, []);

    useEffect(() => {
      let ids: number[] = [];
      regions.map(region => {
        const depth = region.depth ? region.depth - 1 : 0;
        if (depth === 0) {
          ids.push(region.id);
        }
      })
      setVisibleRegions(ids);
      setTableRegions(regions);
    }, [regions]);

    return (
      <div className="App regions-page">
          <div className="w-100">
              <Container fluid>
                  <div className="row">
                      <div className="col-md-12">
                          <h4 className="mb-2 text-start">Regions list</h4>
                          <hr/>
                      </div>
                      <div className="col-md-12">
                          <AlertError error={error} callback={() => setError("")}/>

                          <div className="row">
                              <div className="col-md-6">
                                  <div className="form-group mb-3">
                                      <label>Country</label>
                                      <Select
                                        isClearable={true} options={countries ? countries : []}
                                        onChange={item => setSelectedCountry(item)}
                                      />
                                  </div>
                              </div>
                              <div className="col-md-6 d-flex align-items-center justify-content-between">
                                  <button className="btn btn-custom" onClick={searchRegions}>Search</button>
                                  <button
                                    className="btn btn-outline-custom inherit" disabled={disabledEdit}
                                    onClick={() => beforeOpenEditRegionModal()}
                                  ><Pencil/> Edit selected
                                  </button>
                                  <button
                                    className="btn btn-outline-custom inherit" onClick={mergeRegions}
                                    disabled={disabledMerge}
                                  >
                                      <ArrowsCollapse/> Merge
                                  </button>
                                  <button
                                    className="btn btn-outline-custom inherit"
                                    onClick={() => beforeOpenAddRegionModal()}
                                    disabled={disabledNewRegion}
                                  >
                                      <Plus/> New region
                                  </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {tableRegions.length ?
                                        (
                                            <>
                                                <div className="selected-header">
                                                    <h4>Selected
                                                        regions: {selectedRegions.length ? selectedRegions.length : 0}</h4>
                                                    <label>
                                                        <input type="checkbox" disabled={!canLockCountry} checked={lockCountryChecked} onChange={(e) => lockCountry(e.target.checked, selectedCountry?.value)}/> - Lock country
                                                    </label>
                                                </div>
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                    <tr>
                                                        <th style={{width: "5%"}}>#</th>
                                                        <th>Name</th>
                                                        <th style={{width: "20%"}}>Number of local wines</th>
                                                        <th style={{width: "20%"}}>Number of gustos wines</th>
                                                        <th style={{width: "8%"}}>Merge in</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {tableRegions.map(region => {
                                                        // Count children for the current region.
                                                        const childrenCount = regions.filter(child => String(child.parent_id) === String(region.id))?.length || 0;
                                                        const depth = region.depth ? region.depth - 1 : 0;
                                                        return (
                                                            <tr key={"region-" + region.id} className={`region-record ${!visibleRegions.includes(region.id) ? 'hidden' : ''} ${childrenCount ? 'has-children' : ''}`}>
                                                                <td className="text-center">
                                                                    <input
                                                                      type="checkbox"
                                                                      onChange={e => toggleActions(region.id, e.target.checked)}
                                                                      checked={!!(selectedRegions.length && selectedRegions.includes(region.id))}
                                                                      disabled={checkboxDisabled}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <div
                                                                      className={`region-depth-${depth}`}
                                                                    >
                                                                      {!!childrenCount && (
                                                                        <div className={`region-children-toggle`} onClick={() => {
                                                                            toggleRegionChildren(region.id);
                                                                        }}>
                                                                          {openedParentRegion.includes(region.id) ? <DashSquare /> : <PlusSquare />}
                                                                        </div>
                                                                      )}
                                                                      {region.name}
                                                                    </div>
                                                                </td>
                                                                <td>{winesCounter && winesCounter[region.id] ? winesCounter[region.id] : 0}</td>
                                                                <td>{gustosWinesCounter && gustosWinesCounter[region.id] ? gustosWinesCounter[region.id] : 0}</td>
                                                                <td className="text-center">
                                                                    <input
                                                                      type="radio" name="merge_id"
                                                                      value={region.id}
                                                                      disabled={!!(!selectedRegions.length || (selectedRegions.length && selectedRegions.length <= 1) || (selectedRegions.length && selectedRegions.length >= 2 && !selectedRegions.includes(region.id)))}
                                                                      checked={!!(mergeIn === region.id || (selectedRegions.length && selectedRegions.length >= 2 && !mergeIn && selectedRegions[defaultMergeInIndex] === region.id))}
                                                                      onChange={() => setMergeIn(region.id)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </Table>
                                            </>
                                        )
                                        : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                  <BsModal {...ModalEditRegionProps}>
                      <div className="form-group mb-2">
                          <label>Location</label>
                          {DropdownRegion}
                      </div>
                      <div className="form-group mb-2">
                          <label>Name</label>
                          <input
                            type="text" className="w-100 custom-input-text"
                            defaultValue={selectedRegions.length ? regions.find(e => e.id === selectedRegions[0])?.name : ""}
                            onChange={e => setEditRegionName(e.target.value)}
                          />
                      </div>
                  </BsModal>

                  <BsModal {...ModalAddRegionProps}>
                      <div className="form-group mb-3">
                          <label>Location</label>
                          {DropdownRegion}
                      </div>
                      <div className="form-group mb-3">
                          <label>Name</label>
                          <input
                            type="text" className="w-100 custom-input-text mt-1"
                            onChange={e => setNewRegionName(e.target.value)}
                          />
                      </div>
                  </BsModal>
              </Container>
          </div>
        </div>
    );
}

export default Regions;
